import { Component, OnInit } from '@angular/core';
import {ActivatedRoute,Router} from '@angular/router'
import {HttpClient,HttpParams,HttpResponse,HttpHeaders} from '@angular/common/http';
import {CommonService} from '../../common.service'
import { environment as configs } from 'src/environments/environment';
import * as $ from 'jquery';
@Component({
  selector: 'app-pending',
  templateUrl: './pending.component.html',
  styleUrls: ['./pending.component.css']
})
export class PendingComponent implements OnInit {
   host=configs['ApiHost'];
   penddingTransections:any=[]
   constructor(private activeRoute:ActivatedRoute,private httpClient:HttpClient,private router:Router,public CSF:CommonService) {  this.CSF.setNavs(true); }

   ngOnInit() {
      this.CSF.setNavs(true);
   		this.getpendingpayments().then((resp)=>{
   				this.penddingTransections=resp['data'];
   		})
   }




   // get list of pending payments /csc/get/refund-record
   getpendingpayments(){
  		return this.httpClient.get(this.host+'/csc/pay/pending').toPromise()
   }


   	payagain(challanid){
   		 $('#vlechallanid').val(challanid);
  		$('#vlepay').submit();
   	}

    paystatus(id,challanid){
       this.httpClient.post(this.host+'/csc/pay/status',{merchant_txn:id,challanid:challanid},{headers:new HttpHeaders({'Access-Control-Allow-Credentials':'true'}), withCredentials:true}).subscribe(resp=>{
        //  console.log(resp)
         if(resp['status']==false){
           alert('here')
           this.payagain(challanid);
         }else{
           this.router.navigate(['/payment/receipt/'+challanid])
         }
       })
    }

}
